module.exports = __webpack_public_path__ + "static/media/page4.807e2531.png";